// extracted by mini-css-extract-plugin
export default {"load":"style_load__vVwgi","loader":"style_loader__1LHQR"};